<template>
  <div class="category-content order-content">
    <div class="main-width">
      <div class="order-number">订单编号：{{orderDetailData.orderSn}}</div>
      <div class="order-status">
        <ul>
          <li
            class="order-detail-one order-status-one order-status-default"
            :class="{'yiwancheng': statusActive.one}"
          >
            <div class="order-current-status"></div>
            <div class="order-status-text">提交订单</div>
            <div class="order-status-time">{{createDate}}</div>
            <div class="order-status-time">{{createTime}}</div>
          </li>
          <li
            class="order-detail-two order-status-two order-status-default"
            :class="{'yiwancheng': statusActive.two}"
          >
            <div class="order-current-status"></div>
            <div class="order-status-text">付款成功</div>
            <div class="order-status-time">{{payDate}}</div>
            <div class="order-status-time">{{payTime}}</div>
          </li>
          <li
            class="order-detail-three order-status-two order-status-default"
            :class="{'yiwancheng': statusActive.three}"
          >
            <div class="order-current-status"></div>
            <div class="order-status-text">货商发货</div>
            <div class="order-status-time">{{sendGoodsDate}}</div>
            <div class="order-status-time">{{sendGoodsTime}}</div>
          </li>
          <li
            class="order-detail-four order-status-two order-status-default"
            :class="{'yiwancheng': statusActive.four}"
          >
            <div class="order-current-status"></div>
            <div class="order-status-text">订单完成</div>
            <div class="order-status-time">{{completeDate}}</div>
            <div class="order-status-time">{{completeTime}}</div>
          </li>
        </ul>
      </div>

      <div class="order-content-wrap" v-if="logisticsInfo.length > 0">
        <table class="shelves-table">
          <thead>
            <tr>
              <!-- <th v-if="orderbox"></th> -->
              <th style="width: 400px;">包裹详情</th>
              <th style="width: 300px;"></th>
              <th>物流信息</th>
            </tr>
          </thead>
          <tbody class="order-tbody">
            <tr v-for="(info,idx) in logisticsInfo" :key="idx" style="border-bottom: 1px solid #e5e5e5;">
              <td>
                <div style="display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  padding: 20px;
  box-sizing: border-box;" v-for="(item,index) in info.packetDetails" :key="index">
                  <div style="position: relative;" v-if="orderbox">
                    <img style="width: 80px;height: 80px;" :src="imgAddress + item.picture" @error="error(1)" />
                    <img v-if="item.isOwner > 0" style="width: 22px;height: 22px;position: absolute;z-index: 100;top: initial;left: 0" src="../assets/img/is_owns.png" alt="">
                  </div>
                  <div style="margin-left: 20px;">
                      <div class="line-clamp-1-s" style="color: #494949;">{{item.goodsName}}</div>
                      <div style="color: #999;font-size: 12px;">规格：{{item.specName}}</div>
                      <div style="color: #999;font-size: 12px;">件数：{{item.num}}</div>
                    </div>
                  </div>
              </td>
              <td style="border-left: 1px solid #e5e5e5;">
                <div style="padding: 20px;box-sizing: border-box;">
                <div>
                  物流公司：
                  <span>{{info.expressName}}</span>
                </div>
                <div v-if="info.driverName == ''">
                  收货方式：
                  <span>普通快递</span>
                </div>
                <div>
                  物流单号：
                  <span>{{info.expressNo}}</span>
                </div>
                <div v-if="info.driverName != ''">
                  司机姓名：
                  <span>{{info.driverName}}</span>
                </div>
                <div v-if="info.driverName != ''">
                  手机号：
                  <span>{{info.driverMobile}}</span>
                </div>
                <div v-if="info.driverName != ''">
                  车牌号：
                  <span>{{info.plateNumber}}</span>
                </div>
                </div>
            </td>
            <td style="border-left: 1px solid #e5e5e5;">
              <div class="order-logistics-content" style="border: none;">
                <div class="order-logistics-item-wrap" v-for="(item, index) in info.logisticslList" :key="index">
                  <div
                    class="order-logistics-item"
                    :class="{'current': index===info.logisticslList.length-1}"
                  >
                    <span>{{item.datetime}}</span>
                    <span>{{item.remark}}</span>
                  </div>
                </div>
              </div>
            </td>

            </tr>
          </tbody>
        </table>
      </div>

      <div class="order-content-wrap" v-if="isSendGoods && false">
        <div class="manage-config-info-title">
          <span style="float: left;margin-left: 90px;">包裹详情</span>
          物流信息
        </div>
        <div
        style="padding-left: 560px;"
          :class="orderbox ? 'order-info-contentt' : 'order-info-content'"
          v-for="(info,idx) in logisticsInfo"
        >
          <div style="width: 300px;" class="order-info-baoguo" v-if="orderbox">
            <td style="padding-top: 25px;width: 300px;" class="order-table-image" v-for="(item,index) in info.packetDetails" :key="index">
              <div class="order-table-image-wrap">
                <img :src="imgAddress + item.picture" @error="error(1)" />
                <img v-if="item.isOwner > 0" style="width: 22px;height: 22px;position: absolute;z-index: 100;top: initial;left: 0" src="../assets/img/is_owns.png" alt="">
              </div>
              <div>
                <div class="order-goods-name line-clamp-1-s">{{item.goodsName}}</div>
                <div style="color: #999;font-size: 12px;">规格：{{item.specName}}</div>
                <div style="color: #999;font-size: 12px;">件数：{{item.num}}</div>
              </div>
            </td>
          </div>
          <div :class="orderbox ? 'order-logistics-infoo' : 'order-logistics-info'" style="left: 320px;">
            <div>
              物流公司：
              <span>{{info.expressName}}</span>
            </div>
            <div v-if="info.driverName == ''">
              收货方式：
              <span>普通快递</span>
            </div>
            <div>
              物流单号：
              <span>{{info.expressNo}}</span>
            </div>
            <div v-if="info.driverName != ''">
              司机姓名：
              <span>{{info.driverName}}</span>
            </div>
            <div v-if="info.driverName != ''">
              手机号：
              <span>{{info.driverMobile}}</span>
            </div>
            <div v-if="info.driverName != ''">
              车牌号：
              <span>{{info.plateNumber}}</span>
            </div>
          </div>
          <div class="order-logistics-content">
            <div class="order-logistics-item-wrap" v-for="(item, index) in info.logisticslList">
              <div
                class="order-logistics-item"
                :class="{'current': index===info.logisticslList.length-1}"
              >
                <span>{{item.datetime}}</span>
                <span>{{item.remark}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-content-wrap">
        <div class="manage-config-info-title">
          <div class="order-title-half">收货人信息</div>
          <div class="order-title-half">订单信息</div>
        </div>
        <div class="order-info-content order-all-info">
          <div class="order-linkman-info">
            <div>
              姓名：
              <span>{{orderDetailData.linkMan}}</span>
            </div>
            <div>
              电话：
              <span>{{orderDetailData.mobile}}</span>
            </div>
            <div>
              身份证号：
              <span>{{orderDetailData.idNumber}}</span>
            </div>
            <div>
              收货地址：
              <span>{{address}}</span>
            </div>
          </div>
          <div class="order-info">
            <div>
              父订单编号：
              <span>{{orderDetailData.orderObjectSn}}</span>
            </div>
            <div>
              订单编号：
              <span>{{orderDetailData.orderSn}}</span>
            </div>
            <div>
              交易个数：
              <span>{{orderDetailData.goodsCount}}</span>
            </div>
            <div>
              最终结算金额：
              <span>¥{{orderDetailData.totalCooperatePrice/100}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="order-content-wrap">
        <table class="shelves-table">
          <thead>
            <tr>
              <!-- <th v-if="orderbox"></th> -->
              <th>商品信息</th>
              <th>SKU</th>
              <th>最终结算价</th>
              <th>是否带票</th>
              <th>数量</th>
              <th>是否开票</th>
              <th>运费</th>
            </tr>
          </thead>
          <tbody class="order-tbody">
            <tr class="order-table-item" v-for="(item, index) in goodsList">
              <!-- <td v-if="orderbox" :rowspan="item.packetIdspan" :class="{hidden: item.packetIddis}">
                <span>包裹{{item.packetSn}}</span>
              </td> -->
              <td class="order-table-image">
                <div class="order-table-image-wrap">
                  <img :src="imgAddress + item.navigateImg1" @error="error(1)" />
                  <img v-if="item.selfStoreId > 0" style="width: 22px;height: 22px;position: absolute;z-index: 100;top: initial;left: 0" src="../assets/img/is_owns.png" alt="">
                </div>
                <div>
                  <div class="order-goods-name">{{item.goodName}}</div>
                </div>
              </td>
              <td>
                <div class="order-default-font">{{item.specName}}</div>
                <div class="order-default-font">SKU：{{item.productId}}</div>
              </td>
              <td class="order-default-font">¥{{item.cooperatePrice/100}}</td>
              <td>{{item.isContain}}</td>
              <td class="order-default-font">{{item.quantity}}</td>
              <td class="order-default-font" v-if="orderDetailData.isBill == 1">开发票</td>
              <td class="order-default-font" v-else>未开发票</td>
              <td
                class="order-default-font"
                :rowspan="goodsList.length"
                v-if="index==0"
              >¥{{orderDetailData.freight/100}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../store/index.js";
import {
  orderDetailInfo,
  imgAddress,
  getOrderLogistics
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";

export default {
  data() {
    return {
      userId: store.state.userId,
      orderId: 0,
      imgAddress: imgAddress,
      orderDetailData: {},
      statusActive: {
        one: true,
        two: false,
        three: false,
        four: false
      },
      logisticsInfo: {},
      address: "",
      goodsList: {},
      isSendGoods: false,
      statusText: "交易成功",
      createDate: "",
      createTime: "",
      payDate: "",
      payTime: "",
      sendGoodsDate: "",
      sendGoodsTime: "",
      completeDate: "",
      completeTime: "",
      logisticsList: {},
      isbox: 0,
      orderSn: "",
      orderbox: false,
      getOrderLogistics: {}
    };
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.orderSn = this.$route.query.orderSn;
  },
  mounted() {
    this.init();
    this.islogistics();
  },
  methods: {
    getData(list) {
      //合并table--可查询
      //console.log(list[0]);
      for (let field in list[0]) {
        var k = 0;
        while (k < list.length) {
          list[k][field + "span"] = 1;
          list[k][field + "dis"] = false;
          for (var i = k + 1; i <= list.length - 1; i++) {
            if (list[k][field] == list[i][field] && list[k][field] != "") {
              list[k][field + "span"]++;
              list[k][field + "dis"] = false;
              list[i][field + "span"] = 1;
              list[i][field + "dis"] = true;
            } else {
              break;
            }
          }
          k = i;
        }
      }
      return list;
    },
    error(num) {
      imageError(num, event);
    },
    islogistics() {
      //多包裹显示
      var data = {
        //传参
        orderInfoSn: this.orderSn,
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      var url = getOrderLogistics;
      fetch(url, data).then(res => {
        this.getOrderLogistics = res.data;
        // console.log(res.data.list)
        if (this.getOrderLogistics.isSplitPacket === 0) {
          //判断当前状态是否是多包裹以渲染不同页面
          this.orderbox = false;
        } else if (this.getOrderLogistics.isSplitPacket === 1) {
          //0 否 1 是
          this.orderbox = true;
        }
        if (this.getOrderLogistics.list.length != 0) {
          //判断物流信息是否显示
          this.logisticsInfo = res.data.list;
          this.isSendGoods = true;
          this.orderSn = res.data.orderSn;
        }
      });
    },
    init() {
      //初始化数据
      var data = {
        orderInfoId: this.orderId,
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      var url = orderDetailInfo;
      fetch(url, data).then(res => {
        this.orderDetailData = res.data;
        this.address =
          this.orderDetailData.province +
          this.orderDetailData.city +
          this.orderDetailData.area +
          // this.orderDetailData.street +
          this.orderDetailData.address;

        this.goodsList = res.data.listDetail;
        this.getData(this.goodsList);
        // console.log(this.goodsList);
        var orderStatus = res.data.status;
        if (orderStatus == 1) {
          this.statusActive.one = true;
          this.statusActive.two = false;
          this.statusActive.three = false;
          this.statusActive.four = false;
        } else if (orderStatus == 2) {
          this.statusActive.one = true;
          this.statusActive.two = true;
          this.statusActive.three = false;
          this.statusActive.four = false;
        } else if (orderStatus == 3) {
          this.statusActive.one = true;
          this.statusActive.two = true;
          this.statusActive.three = true;
          this.statusActive.four = false;
        } else {
          this.statusActive.one = true;
          this.statusActive.two = true;
          this.statusActive.three = true;
          this.statusActive.four = true;
          if (orderStatus == 7) {
            this.statusText = "交易失败";
          }
        }
        if (this.orderDetailData.createTime != null) {
          this.createDate = this.orderDetailData.createTime.substring(0, 10);
          this.createTime = this.orderDetailData.createTime.substring(11, 19);
        }
        if (this.orderDetailData.payTime != null) {
          this.payDate = this.orderDetailData.payTime.substring(0, 10);
          this.payTime = this.orderDetailData.payTime.substring(11, 19);
        }
        if (this.orderDetailData.sendGoodsTime != null) {
          this.sendGoodsDate = this.orderDetailData.sendGoodsTime.substring(
            0,
            10
          );
          this.sendGoodsTime = this.orderDetailData.sendGoodsTime.substring(
            11,
            19
          );
        }
        if (this.orderDetailData.completeTime != null) {
          this.completeDate = this.orderDetailData.completeTime.substring(
            0,
            10
          );
          this.completeTime = this.orderDetailData.completeTime.substring(
            11,
            19
          );
        }
      });
    }
  }
};
</script>
<style scoped>
.hidden {
  display: none;
}
.line-clamp-1-s{
    overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis; display:-webkit-box; -webkit-box-orient:vertical; -webkit-line-clamp:1;
}
</style>



// WEBPACK FOOTER //
// OrderDetail.vue?55892bb6